export class Rule {

    private internalId: string;
    private centerInternalId: string;
    private creationDate: number;
    private modificationDate: number;
    private idDesk: string;
    private ruleOrder: number;
    private ruleOperator: string;
    private ruleValue: number;
    private ruleAction: string;
    private turnDeskInternalId: string;

    constructor(internalId?: string, centerInternalId?: string, creationDate?: number, modificationDate?: number, idDesk?: string, ruleOrder?: number, ruleOperator?: string, ruleValue?: number, ruleAction?: string, turnDeskInternalId?: string) {
        this.internalId = internalId;
        this.centerInternalId = centerInternalId;
        this.creationDate = creationDate;
        this.modificationDate = modificationDate;
        this.idDesk = idDesk;
        this.ruleOrder = ruleOrder;
        this.ruleOperator = ruleOperator;
        this.ruleValue = ruleValue;
        this.ruleAction = ruleAction;
        this.turnDeskInternalId = turnDeskInternalId;
    }

    public get InternalId() {
        return this.internalId;
    }

    public set InternalId(internalId) {
        this.internalId = internalId;
    }

    public get CenterInternalId() {
        return this.centerInternalId;
    }

    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }

    public get CreationDate() {
        return this.creationDate;
    }

    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }

    public get ModificationDate() {
        return this.modificationDate;
    }

    public set ModificationDate(modificationDate) {
        this.modificationDate = modificationDate;
    }

    public get IdDesk() {
        return this.idDesk;
    }

    public set IdDesk(idDesk) {
        this.idDesk = idDesk;
    }

    public get RuleOrder() {
        return this.ruleOrder;
    }

    public set RuleOrder(ruleOrder) {
        this.ruleOrder = ruleOrder;
    }

    public get RuleOperator() {
        return this.ruleOperator;
    }

    public set RuleOperator(ruleOperator) {
        this.ruleOperator = ruleOperator;
    }

    public get RuleValue() {
        return this.ruleValue;
    }

    public set RuleValue(ruleValue) {
        this.ruleValue = ruleValue;
    }

    public get RuleAction() {
        return this.ruleAction;
    }

    public set RuleAction(ruleAction) {
        this.ruleAction = ruleAction;
    }

    public get TurnDeskInternalId() {
        return this.turnDeskInternalId;
    }

    public set TurnDeskInternalId(turnDeskInternalId) {
        this.turnDeskInternalId = turnDeskInternalId;
    }

}
